var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerPaperIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.e,.i{fill:#3c3c46;}.b,.e,.f{opacity:0.15;}.c,.l{fill:#3ca4ef;}.c,.d,.f,.g,.h{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d,.k{fill:#89d9fb;}.d,.e,.f,.g,.h,.i,.j,.k,.l{fill-rule:evenodd;}.f,.h{fill:#ffefe0;}.g,.j{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-paper-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 28.16,
    y: 30.9,
    width: 91.68,
    height: 104.19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 23.16,
    y: 22.91,
    width: 84.01,
    height: 104.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 28.16,
    y: 16.91,
    width: 84.01,
    height: 104.19
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 20.16,
    y: 10.91,
    width: 84.01,
    height: 104.19
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "108.17 43.1 108.17 109.1 24.16 109.1 24.16 4.91 69.99 4.91 108.17 43.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "108.17 43.1 72.04 53.33 72.04 13.23 108.17 43.1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "69.98 15.14 108.17 4.91 108.17 43.1 69.98 15.14"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "108.17 43.1 69.99 43.1 69.99 4.91 108.17 43.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "69.98 4.91 108.17 4.91 108.17 43.1 69.98 4.91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M45,78.57l7.44-27.82a2.71,2.71,0,0,1,5.24,0l6.11,22.83a6.64,6.64,0,0,1,1.51-.63,13.35,13.35,0,1,1,13.31,8v8.59H91.22a1,1,0,1,1,0,2.09H41.11a1,1,0,0,1,0-2.09H54.38V82H47.6A2.71,2.71,0,0,1,45,78.57ZM68,89.58H76.5V81h0a13.23,13.23,0,0,1-2.79-.52A6.72,6.72,0,0,1,68,86v3.55Zm-11.56,0h9.67V86a6.72,6.72,0,0,1-5.24-4H56.47v7.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M47.11,79.65a.61.61,0,0,0,.49.24h6.78V77.35h0V74.17l-2.31-2.31a1,1,0,1,1,1.48-1.48l.83.83V68.3a1,1,0,1,1,2.09,0v5.43h0v1.09l1.71-1.71a1,1,0,1,1,1.48,1.48l-3.18,3.18v2.11h3.93c0-.16,0-.33,0-.5A6.67,6.67,0,0,1,62,75L55.64,51.29a.62.62,0,0,0-1.2,0L47,79.11A.61.61,0,0,0,47.11,79.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M67.09,77.13a.94.94,0,0,1,.94.94v1.66l.37-.37a.94.94,0,1,1,1.33,1.33L68,82.39v1.52a4.61,4.61,0,0,0-.94-9.13h-.24a4.61,4.61,0,0,0-.7,9.12V82h0V78.07A.94.94,0,0,1,67.09,77.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M77.54,64a1,1,0,0,1,1,1v5.88h0v1.93l2.51-2.51a1,1,0,0,1,1.48,1.48l-4,4v3.11A11.26,11.26,0,1,0,67.46,72.7a6.71,6.71,0,0,1,6.23,5.57,11.13,11.13,0,0,0,2.8.63V75.34h0v-4l-2.92-2.92a1,1,0,0,1,1.48-1.48l1.44,1.44V65A1,1,0,0,1,77.54,64Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerPaperIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-paper-icon.a3c37660fd3ca9d78bc5b5512e5fbafc.svg";
export { ForwardRef as ReactComponent };